module.exports = __webpack_public_path__ + "img/sarah_rabe_4.7897a491.jpg";